import { memo, useCallback, useMemo } from 'react';
import { Row, Col } from 'react-bootstrap';
import { BzHeading, BzChip, BzCard, BzButton } from '../../../components';
import { getScripOrderInfo, getExchangeWiseScripInfo } from '../../../redux/actions/orders';
import { WATCHLIST_GRID_INDEX, MULTIPLIER, TRADING_NOT_ALLOWED_MSG } from "../../../utils/global_variables";
import { useDispatch, useSelector } from 'react-redux';
import { handleModal } from '../../../redux/actions/modals';
import { _checkSegmetAllowed, _getScripsInfo } from '../../../controllers';
import { ORDER_ENTRY_GRID_REF, convertScripResponseWatchlistGrid, getApiExchangeNameFromMktSegId, getMktSegIdFromMappedMktSegId, getToFixedParseFloat, isUserIsAGuest } from '../../../utils/global_functions';
import moment from "moment";
import { setScripOverviewData } from '../../../redux/actions/marketOverview';
import { getScripbyTokenAndMktSegId } from '../../../apis';
import { toastConfig } from '../../../redux/actions/toast';

const LivePulseCard = ({ eachItem, tabId, style, id, exchangeState }) => {
    const dispatch = useDispatch();
    const objLoginSession = useSelector(state => state.auth.objLoginSession);

    // Parshva Shah - 07/11/2023  - BT-107438 Breeze - Dashboard - Live Pulse - Start
    let onBuySellClick = useCallback(async (strBuySell) => {
        if (!isUserIsAGuest('buy_sell')) { //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
            // let mkt = `${exchangeState.split(' ').join('_')}_${tabId}`;
            // if (tabId === 'COMM') {
            //     mkt = `${exchangeState.split(' ').join('_')}`;
            // }
            // if (tabId === 'CUR') {
            //     mkt = `${exchangeState.slice(0, 3)}_${tabId}`;
            // }
            if (_checkSegmetAllowed(eachItem?.strExchangeSegment, objLoginSession?.data?.exchanges)) {
                const resPonse = await _getScripsInfo([{ mkt: eachItem?.strExchangeSegment, token: eachItem?.nToken }]);
                let arrScripDetails = convertScripResponseWatchlistGrid(resPonse.data.objScripsResp.result)[0];
                arrScripDetails[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] = parseFloat(eachItem?.price);
                arrScripDetails[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] = eachItem?.nPercChange;
                ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: getToFixedParseFloat(eachItem?.price, arrScripDetails[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) }));

                dispatch(getScripOrderInfo({ isBuySell: strBuySell === 'BUY' ? 0 : 1, activeExchangeId: arrScripDetails[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData: arrScripDetails }));
                dispatch(getExchangeWiseScripInfo(arrScripDetails));
                dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }], true));
            } else {
                dispatch(toastConfig({ autoDismiss: true, show: true, message: TRADING_NOT_ALLOWED_MSG }));
            }
        } else { } //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End

    }, [dispatch, eachItem, exchangeState, tabId]);
    // Parshva Shah - 07/11/2023  - BT-107438 Breeze - Dashboard - Live Pulse - End

    const livePulseDate = moment(eachItem?.date, "DDMMM'YYYY").format("DD MMM'YY");

    const [strLtpChange, nLtpChange] = useMemo(() => {
        const number = (eachItem?.price * eachItem?.nPercChange) / MULTIPLIER?.HUNDRED;
        const nLtpChange = Number(number.toFixed(2));
        let strLtpChange = nLtpChange.toString();
        if (nLtpChange > 0) {
            strLtpChange = '+' + nLtpChange.toString();
        } else { }
        return [strLtpChange, nLtpChange];
    }, [eachItem]);
    // SrikanthR- 10-07-2024 :BT-138203 Require watchlist grid popover for scrips   --Start

    const onClickCard = useCallback(async (rmdDetails, e) => {
        e.stopPropagation();
        const arrScrips = [{ mkt: getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(rmdDetails?.nMarketSegmentId)), token: rmdDetails?.nToken }];
        const objResp = await getScripbyTokenAndMktSegId(arrScrips);
        const gridFormatData = convertScripResponseWatchlistGrid(objResp?.data?.result);
        await dispatch(setScripOverviewData([...gridFormatData[0]]));
        dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }]));
    }, [dispatch]);
    // SrikanthR- 10-07-2024 :BT-138203 Require watchlist grid popover for scrips   --end


    return (
        <BzCard key={id} className='live-pulse-card' data-testid={`live-pulse-card-${id}`} style={style}>
            <Row className='g-0 mb-4'>
                <Col md={9}>
                    <Row className='g-0 mb-2'>
                        <Col className='d-flex justify-content-start align-items-start align-self-center'>
                            <BzHeading className='font-medium font-size5 color-text text-uppercase text-truncate me-2' onClick={(e) => onClickCard(eachItem, e)}>{eachItem?.companyName}</BzHeading>
                            <div className='chips-wrap'>
                                <BzChip className='exchange-chip '>{exchangeState}</BzChip>
                            </div>
                            {/* {eachItem.company_age !== null ? <BzChip className='badge badge-negative ms-2'>{eachItem.company_age}</BzChip> : null} */}
                        </Col>
                    </Row>
                    <Row className='g-0'>
                        {tabId !== 'EQ' ? <div className='font-regular font-size4 color-text'>{eachItem?.expiry} {eachItem?.nStrikePrice > 0 ? `${eachItem?.nStrikePrice} ${eachItem?.sOptionType}` : null}</div> : null}
                        <Col className='d-flex justify-content-start align-self-center'>
                            <div className='font-medium font-size4 color-text'>{eachItem?.price}</div>
                            <div className={`font-regular font-size4 color-text ms-1 ${nLtpChange < 0 ? 'color-negative' : 'color-positive'}`} >{strLtpChange}</div>
                            <div className={`font-regular font-size4 color-text ms-1 ${eachItem?.nPercChange < 0 ? 'color-negative' : 'color-positive'}`}>({eachItem?.nPercChange > 0 ? '+' + eachItem?.nPercChange : eachItem?.nPercChange}%)</div>
                        </Col>
                    </Row>
                </Col>
                <Col md={3} className='d-flex justify-content-end align-items-start'>
                    <BzButton data-testid={`live-pulse-card-${id}-buy-button`} className='btn btn-positive btn-sm text-capitalize ms-2' onClick={() => onBuySellClick('BUY')}>B</BzButton>
                    <BzButton data-testid={`live-pulse-card-${id}-sell-button`} className='btn btn-negative btn-sm text-capitalize ms-2' onClick={() => onBuySellClick('SELL')}>S</BzButton>
                </Col>
            </Row>
            <Row className='g-0 mb-3'>
                <Col className='chips-wrap'>
                    <BzChip className={`chips  ${eachItem?.ltpClass === 'color-negative' ? 'negative-chip' : eachItem?.ltpClass === 'color-positive' ? 'positive-chip' : 'default-chip'}`}>{eachItem?.sSupport}</BzChip>
                </Col>
            </Row>
            <Row className='g-0'>
                <Col>
                    <div className='font-regular font-size1 color-subtext'>{livePulseDate} {eachItem?.time}</div>
                </Col>
            </Row>
        </BzCard>
    );
};

export default memo(LivePulseCard);